import React from 'react';
import {Stack, Box, styled} from '@mui/material';
import {TruvuAppBar} from '../../../../components/containers/TruvuAppBar';

interface TourPageContainerProps {
  isPortrait: boolean;
  tourSize?: {width: number; height: number; aspectRatio: number} | null;
  onGoBack?: () => void;
  showAccount?: boolean;
  tourPlayer: React.ReactNode;
  tourInfo: React.ReactNode;
  agentInfo?: React.ReactNode;
}

const MainWrapper = styled(Stack)({
  minHeight: '100svh',
  padding: '0 20px 20px',
  width: '100%',
  position: 'relative',
});

const MainContainer = styled(Stack)({
  flex: 1,
  height: '100%',
  margin: 'auto',
  width: '100%',
  maxWidth: '1000px',
  position: 'relative',
});

const TourPlayerContainer = styled(Box)({
  borderRadius: '8px',
  overflow: 'hidden',
  backgroundColor: '#758089',
});

const DetailsContainer = styled(Stack)({
  minHeight: 0,
});

export function TourPageContainer({
  isPortrait,
  tourSize,
  onGoBack,
  showAccount,
  tourPlayer,
  tourInfo,
  agentInfo,
}: TourPageContainerProps) {
  const getTourPlayerContainerProps = () => {
    if (!tourSize?.aspectRatio) {
      return isPortrait ? {flex: 1} : {width: '100%', height: '60%'};
    }

    if (isPortrait) {
      return {
        height: tourSize.height,
        width: tourSize.width,
        sx: {
          aspectRatio: tourSize?.aspectRatio.toString(),
          maxWidth: '100%',
        },
      };
    }

    return {
      width: '100%',
      sx: {
        aspectRatio: tourSize?.aspectRatio.toString(),
        maxHeight: '100%',
      },
    };
  };

  if (isPortrait) {
    return (
      <MainWrapper>
        <MainContainer>
          <TruvuAppBar onGoBack={onGoBack} showAccount={showAccount} />

          <Stack direction="row" spacing={3}>
            <TourPlayerContainer
              {...getTourPlayerContainerProps()}
              position={'sticky'}
              top={0}
              flexShrink={0}
            >
              {tourPlayer}
            </TourPlayerContainer>
            <DetailsContainer flex={1}>
              <Stack direction="column-reverse" flex={1} spacing={3}>
                {agentInfo}
                {tourInfo}
              </Stack>
            </DetailsContainer>
          </Stack>
        </MainContainer>
      </MainWrapper>
    );
  }

  return (
    <MainWrapper overflow={'auto'}>
      <MainContainer>
        <TruvuAppBar
          onGoBack={onGoBack}
          showAccount={showAccount}
          position="sticky"
          top={0}
          zIndex={1000}
          bgcolor="background.default"
        />

        <Stack flex={1} spacing={3} minHeight={0}>
          <TourPlayerContainer {...getTourPlayerContainerProps()}>
            {tourPlayer}
          </TourPlayerContainer>

          <DetailsContainer flex={1}>
            <Stack direction="row" spacing={3}>
              {agentInfo}
              {tourInfo}
            </Stack>
          </DetailsContainer>
        </Stack>
      </MainContainer>
    </MainWrapper>
  );
}
